import { useApiQuery } from '~/hooks';
import { getProfileApi } from '../repository';

export const PROFILE_QUERY_KEYS = {
  PROFILE: 'user-profile',
};

/**
 * Query hook to fetch current user's profile
 * @returns React Query result with user profile data
 */
export const useGetProfileQuery = () => {
  return useApiQuery({
    queryKey: [PROFILE_QUERY_KEYS.PROFILE],
    queryFn: () => getProfileApi(),
  });
};
